import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import styles from './VillagePrices.css';
import { NBSP } from '../../../constants';
import { PriceDisclaimerContainer } from '../../../containers/PriceDisclaimerContainer';

export interface IVillagePricesProps {
  priceMax?: number;
  priceMin?: number;
}

export const VillagePrices = (props: IVillagePricesProps) => {
  const { priceMin, priceMax } = props;
  const showPrice = (priceMax || priceMin || 0) > 0;

  return (
    <div className={styles['container']}>
      {!showPrice ? (
        <div className={styles['min_max_prices']}>
          <div className={styles['min_max_prices_item']}>Цена уточняется</div>
          <div className={styles['no_village_price']}>у{NBSP}застройщика</div>
        </div>
      ) : (
        <div className={styles['min_max_prices']}>
          {!!priceMin && (
            <div className={styles['min_max_prices_item']}>
              <span className={styles['preposition']}>от</span>
              {NBSP}
              <span>{numberToPrettyString(Math.trunc(priceMin))}</span>
              {!priceMax && <span className={styles['currency']}>{NBSP}₽</span>}
              {!priceMax && <PriceDisclaimerContainer size="28" position="bottom" />}
            </div>
          )}
          {!!priceMax && (
            <div className={styles['min_max_prices_item']}>
              <span className={styles['preposition']}>до</span>
              {NBSP}
              <span>{numberToPrettyString(Math.trunc(priceMax))}</span>
              <span className={styles['currency']}>{NBSP}₽</span>
              <PriceDisclaimerContainer size="20" position="bottom" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
